import { render, staticRenderFns } from "./brBigDataIndex.vue?vue&type=template&id=74dfaa45&scoped=true"
import script from "./brBigDataIndex.vue?vue&type=script&lang=js"
export * from "./brBigDataIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfaa45",
  null
  
)

export default component.exports